import styled from "styled-components";
import { device } from "../device";

export const StyledRadioFieldContainerEvents = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 30px;
    width: 100%;

    @media ${device.tablet} {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        grid-column-gap: 30px;
    }
`

interface StyledCityCheckboxProps {
  isChecked: boolean;
}

export const StyledCityCheckbox = styled.div<StyledCityCheckboxProps>`
  background-color: #fff;
  border: none;
  border-radius: 12px;
  color: ${(props) => props.theme.colors.fontBlack};
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 25px;
  cursor: pointer;
  height: 125px;
  position: relative;
  user-select: none;
  box-sizing: content-box;
  box-shadow: ${props => props.isChecked ? "0px 0px 0px 4px rgb(247 192 58)" : "2px 4px 16px rgb(0 0 0 / 16%)"} ;

    * > img {
        z-index: 0;
        border-radius: 12px;
        filter: brightness(0.65);
    }

  div {
    display: flex;
    align-items: center;
    z-index: 10;
  }

  &:focus {
    border: 1px solid ${(props) => props.theme.colors.primary};
  }

  .label-box {
      display: flex;
      flex-direction: column; 
      align-items: flex-start;

      .location {
            cursor: pointer;
            font-weight: 500;
            font-size: 26px;
            text-align: center;
            text-shadow: 4px 3px 6px black;
            color: ${(props) => props.theme.colors.fontWhite};
            line-height: 29px;
            user-select: none;
            text-align: left;
      }
      .date {
            cursor: pointer;
            font-weight: 300;
            font-size: 23px;
            text-align: center;
            text-shadow: 4px 3px 6px black;
            color: ${(props) => props.theme.colors.fontWhite};
            line-height: 30px;
            user-select: none;
      }
  }
`;


export const StyledCheckbox = styled.input`
    height: 22px;
    width: 22px;
    min-width: 22px;
    margin-right: 22px;
`;